










import { Component, Vue } from "vue-property-decorator";
import Header from "@/components/header/OLoginHeader.vue";
import OrganizationUserList from "@/components/OrganizationUserList.vue";
import Footer from "@/components/Footer.vue";
import AuthModule from "@/store/auth";

@Component({
  components: {
    Header,
    OrganizationUserList,
    Footer,
  },
})
export default class OUserList extends Vue {
  // アカウントの取得
  private get me() {
    return AuthModule.me;
  }
}
